import TransactionSummary from "../../model/TransactionSummary";
import { Column, Row, Select } from "../../../components";
import * as label from '../../../shared/util/label';
import { Button, Collapse, Nav, Tab, Table } from "react-bootstrap";
import React, { Fragment, useCallback, useEffect, useMemo, useState } from "react";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import CustomerTransactionSummary from "../../model/CustomerTransactionSummary";
import "../RightPanel/transactionSummaryList.scss"
import PolicyMappingDataService from "../PolicyMappingDataService";
import { PolicyDtoRead } from "../../../customer/model/PolicyDtoRead";
import * as constant from '../../../shared/util/constant';
import Logger from "../../../shared/services/Logger";
import { checkEmptyString, preCommaString } from "../../../shared/util/stringManipulation";
import moment from "moment";
import { getSpinnerContext } from "../../../shared/services/SpinnerContext/SpinnerContext";
import { preventDefault } from "@fullcalendar/core/internal";
import { toast } from "react-toastify";
import CreateCustomerAndApplyPolicyPopup from "./CreateCustomerAndApplyPolicyPopup";
import AtmsCustomers from "../../model/AtmsCustomers";
import { CustomerSearch } from "../../model/CustomerSearch";
import ApplyPolicyPopup from "./ApplyPolicyPopup";
import ErrorMessageHandler from "../../../shared/util/ErrorMessageHandler";
import { ConfirmModal } from "../../../shared/components/confirmModal";
import { CommonUtility } from "../../../Services/CommonUtility";
import { ApplyTransactionDto, ApplyShellTransactionDto } from "../../model/ApplyTransactionDto";
import { TransactionMetadata } from "../../model/TransactionMetadata";


interface Props {
    transactionSummaryData: CustomerTransactionSummary[]
    atmCustomerData: AtmsCustomers[]
    transactionSummary: TransactionSummary
    GetTransactionSummaryList: (customerFiler: CustomerSearch) => void
    GetCustomerFromATMSList: (customerFiler: CustomerSearch) => void
    insuredNameArray: any
    insuredSummaryId: any
    isNewCustomerLoad: boolean
    setNewCustomerLoad: (boolean) => void
    isNewCarrerLoad: boolean
    onStatusChange?: () => void;
    onApplySuccess?: () => void;
    defaultSelectedTab?: string;
    hasUIComponentViewAccess?: boolean,
    hasUIComponentReadAccess?: boolean,
    selectedTransactionIds?: string[],
    setSelectedTransactionIds?: (ids: string[]) => void,
    transactionMetadataList?: TransactionMetadata[],
}
const TransactionSummaryListPanel = (props: Props) => {
    const initCustomerTransactionData: CustomerTransactionSummary = {
        id: '',
        firstName: '',
        lastName: '',
        address1: '',
        city: '',
        state: '',
        zipCode: '',
        agencyDecr: '',
        term: '',
        policyReadDTO: [],
        fetched: false,
        errorText: ''
    }
    const [open, setOpen] = useState({});
    const [openPolicy, setPolicyOpen] = useState({});
    const [openAdditionalInfo, setAdditionalInfoOpen] = useState({});
    const [firstNameSearch, isFirstNameSearch] = useState<boolean>(false);
    const [lastNameSearch, islastNameSearch] = useState<boolean>(false);
    const [addressSearch, isAddressSearch] = useState<boolean>(false);
    const [policyNumberSearch, isPolicyNumberSearch] = useState<boolean>(false);
    const [transactionSummaryList, setTransactionSummaryList] = useState<CustomerTransactionSummary[]>([]);
    const [atmsCustomerList, setAtmsCustomerList] = useState<AtmsCustomers[]>([]);
    const policyMappingDataService = new PolicyMappingDataService();
    const [policyList, SetPolicyList] = useState<PolicyDtoRead[]>([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [customerId, setcustomerId] = useState('');
    const [policyId, setpolicyId] = useState('');
    const [showCreateCustomerPopup, setShowCreateCustomerPopup] = useState(false);
    const [popupData, setPopupData] = useState({ firstName: '', lastName: '', middleName: '', parentCompany: '', writtingCompany: '' });
    const [applyPopupData, setApplyPopupData] = useState({ firstName: '', lastName: '', middleName: '', agencyId: '', parentCompany: '', writtingCompany: '', showCompanyInfo: false });
    const [agencyList, setAgencyList] = useState([]);
    const [sourcesTypeList, setSourcesTypeList] = useState([]);
    const [activeTab, setActiveTab] = useState('tab1');
    const [selectedRowId, setSelectedRowId] = useState<string | null>(null);
    const [selectedCS2PolicyId, setSelectedPolicyId] = useState<string | null>(null);
    const [priorPolicyId, setSelectedPriorPolicyId] = useState<string | null>(null);
    const [selectedCustomerId, setSelectedCustomerId] = useState<string | null>(null);
    const [selectedCustomerNumber, setSelectedCustomerNumber] = useState<number | null>(null);
    const [sourceId, setSourceId] = useState<string | null>(null);
    const [sourceType, setSourceType] = useState<string | null>(null);
    const [atmsLeadId, setAtmsLeadId] = useState('');
    const [atmsSelectedRowId, setAtmsSelectedRowId] = useState<string | null>(null);
    const [showApplyPolicyPopup, setShowApplyPolicyPopup] = useState(false);
    const [agencyId, setAgencyId] = useState<string | null>(null);
    const [sourceTypeId, setSourceTypeId] = useState<string | null>(null);
    const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
    const [confirmationResolver, setConfirmationResolver] = useState<null | ((result: boolean) => void)>(null);
    const errorMessageHandler = new ErrorMessageHandler();
    const [confirmationLabel,setConfirmationLabel] = useState('');
    const [companyId, setCompanyId] = useState<string | null>(null);
    const [parentCompanyId, setParentCompanyId] = useState<string | null>(null);

    // Advanced search rows state (multiple filters)
    const [advancedSearchRows, setAdvancedSearchRows] = useState([]);
    const [usStates, setUsStates] = useState<{ value: string; label: string; isInactive?: boolean }[]>([]);
    // Helper for unique row ids
    const [nextAdvancedRowId, setNextAdvancedRowId] = useState(1);
    // Track if user has performed advanced search
    const [hasSearched, setHasSearched] = useState(false);

    useEffect(() => {
        const fetchStates = async () => {
            const states = await policyMappingDataService.fetchUsStates();
            setUsStates(states);
        };

        fetchStates();
    }, []);


    const handleToggle = (id, agencyId, custNumber) => {
        setOpen((prev) => ({ ...prev, [id]: !prev[id] }));
        setSelectedPolicyId(''); // reset selected policy id
        setSelectedPriorPolicyId(''); // reset selected prior policy id
        setSelectedRowId(id); // highlight row
        setAtmsLeadId('');
        setSourceId(null);
        setSourceTypeId(null);
        setSelectedCustomerId(id); // set selected customer id
        setSelectedCustomerNumber(custNumber);
        setAgencyId(agencyId)
        const customer: string[] = []
        customer.push(id);
        GetPolicySummaryList(customer);
        setCompanyId(null);
        setParentCompanyId(null);
    };

    const handlePolicyToggle = (id, priorPolicyId, sorId, sourceTypeId, companyId, writingCompanyId) => {
        setPolicyOpen((prev) => ({ ...prev, [id]: !prev[id] }));
        setSelectedPolicyId(id); // highlight policy row
        setSelectedPriorPolicyId(priorPolicyId); // highlight prior policy row
        setAdditionalInfoOpen(true)
        setpolicyId(id);
        setSourceId(sorId);
        setSourceTypeId(sourceTypeId);
        setCompanyId(writingCompanyId);
        setParentCompanyId(companyId);
    }

    const isShowCompanyInfoType = (type: string) => {
        const allowedTypes = ["NBS", "REW", "RWL", "RIX", "PCH", "XLC"];
        return allowedTypes.includes(type);
    };

    const SHELL_TRANSACTION_TYPES = ["PCH", "XLC"];
    const CUSTOMER_CREATION_TYPES = ["NBS", "SYN", "REW", "RWL", "RIX", "PCH", "XLC"];

    const isShellApplyRequired = () => {
        return SHELL_TRANSACTION_TYPES.includes(props.transactionSummary?.cycleBusinessPurposeCode) && !selectedCS2PolicyId;
    };

    const handleApplySuccess = () => {
        if ((props.selectedTransactionIds?.length || 0) <= 1 && props.onApplySuccess) {
            props.onApplySuccess();
        } else if (props.onStatusChange) {
            props.onStatusChange();
        }
    };

    const buildShellDto = (sourceId: string, sourceType: string, parentCompanyId: string, writtingCompanyId: string, options?: { createCustomer?: boolean, agencyId?: string, isLeadFound?: boolean, leadId?: string }): ApplyShellTransactionDto => {
        return {
            policyId: props.insuredSummaryId,
            custNo: options?.createCustomer || options?.isLeadFound ? '' : selectedCustomerId,
            sourceId: sourceId,
            sourceType: sourceType,
            cs2PolicyId: null,
            cs2PriorPolicyId: null,
            transactionTypeCode: props.transactionSummary.cycleBusinessPurposeCode,
            lob: props.transactionSummary.lineOfBusinessCode,
            parentCompanyId: parentCompanyId,
            writtingCompanyId: writtingCompanyId,
            cs2CustomerNumber: options?.createCustomer || options?.isLeadFound ? 0 : selectedCustomerNumber,
            createCustomer: options?.createCustomer || false,
            agencyId: options?.agencyId || null,
            isLeadFound: options?.isLeadFound || false,
            leadId: options?.leadId || null,
            overridenData: {
                premium: props.transactionSummary?.modifiedPremium,
                effectiveDate: props.transactionSummary?.modifiedEffectiveDate,
                polExpDate: props.transactionSummary?.modifiedExpirationDate,
                mailAddress1: props.transactionSummary?.modifiedMailingAddress1,
                mailAddress2: props.transactionSummary?.modifiedMailingAddress2,
                mailCity: props.transactionSummary?.modifiedMailingCity,
                mailState: props.transactionSummary?.modifiedMailingState,
                mailZipCode: props.transactionSummary?.modifiedMailingZip,
                address1: props.transactionSummary?.modifiedPropertyAddress1,
                address2: props.transactionSummary?.modifiedPropertyAddress2,
                city: props.transactionSummary?.modifiedPropertyCity,
                state: props.transactionSummary?.modifiedPropertyState,
                zipCode: props.transactionSummary?.modifiedPropertyZip
            },
            checkPolicyExistsInCs2: false,
            isTSADetailFound: false,
        };
    };


    const GetPolicySummaryList = async (customer: string[]) => {
        try {
            var customerTrsacList = [...transactionSummaryList]
            let policy = customerTrsacList.find((cust) => cust.id === customer[0]);
            setcustomerId(customer[0]);
            if (!policy.fetched) {
                var policySummaryList = await policyMappingDataService.fetchPolicySumarryByCustomerId(customer);

                // --- Refactored logic to set 'isLatest' directly ---
            if (policySummaryList.length > 0) {
                // Find the latest policy by effective date
                let latestIndex = 0;

                let latestDate = new Date(policySummaryList[0].polEffDate).getTime();
                for (let i = 1; i < policySummaryList.length; i++) {
                    const currentDate = new Date(policySummaryList[i].polEffDate).getTime();
                    if (currentDate > latestDate) {
                        latestDate = currentDate;
                        latestIndex = i;
                    }
                }
                // Set isLatest for all, only true for the latest
                policySummaryList.forEach((p, idx) => {
                    p.isLatest = idx === latestIndex;
                });
            }
            // --- End refactored logic ---

                SetPolicyList(policySummaryList)
                const { showSpinner } = getSpinnerContext();
                showSpinner();
                var index = customerTrsacList.findIndex((cust) => cust.id === customer[0])
                if (index > -1) {
                    customerTrsacList[index].policyReadDTO = [];
                    customerTrsacList[index].policyReadDTO = policySummaryList;
                    customerTrsacList[index].fetched = true;
                    if (policySummaryList.length > 0) {
                        setTransactionSummaryList(customerTrsacList);
                    }
                }
                setTimeout(() => {
                    const { hideSpinner } = getSpinnerContext();
                    hideSpinner();
                }, 3000);

            }
            else {
                SetPolicyList([])
            }
        }
        catch (error) {
            SetPolicyList([])
            var customerTrsacList = [...transactionSummaryList]
            var index = customerTrsacList.findIndex((cust) => cust.id === customer[0])
            if (index > -1) {
                customerTrsacList[index].errorText = 'No Policy found for this customer'
                customerTrsacList[index].policyReadDTO = [];
                customerTrsacList[index].fetched = true;
                setTransactionSummaryList(customerTrsacList);
            }
            Logger.logError(constant.UnMatchedPolicy.ERROR_WHILE_FETCHING_CARRIER_MAPPING_LIST, error)
        }
    }

    const resetState = () => {
        setSourceId(null);
        setSourceTypeId(null);
        setSelectedPolicyId(null); // reset selected policy id
        setSelectedPriorPolicyId(null); // reset selected prior policy id
        setSelectedRowId(null); // highlight row
        setSourceId(null);
        setSourceTypeId(null);
        setSelectedCustomerId(null); // set selected customer id
        setAtmsSelectedRowId(null);
        setcustomerId('');
        setOpen(false);
        setPolicyOpen(false);
    }

    const showConfirmModal = () => {
        setShowConfirmationPopup(true);
        return new Promise<boolean>((resolve) => {
            setConfirmationResolver(() => resolve);
        });
    };

    const handleConfirm = (result: boolean) => {
        setShowConfirmationPopup(false);
        if (confirmationResolver) {
            confirmationResolver(result);
            setConfirmationResolver(null);
        }
    };
    // --- Multi-Apply Logic ---

    /** Validates preconditions for applying multiple transactions.
     *  Returns { valid: true } or { valid: false, message: string }.
     *  Add new rules here as requirements evolve. */
    /** Checks that all selected transactions share the same policy #, effective date, and expiration date.
     *  Returns null if valid, or an error message string if not. */
    const validateGroupConsistency = (): string | null => {
        const selectedIds = props.selectedTransactionIds || [];
        const metadataList = props.transactionMetadataList || [];
        const selectedMetadata = selectedIds
            .map(id => metadataList.find(m => m.id === id))
            .filter(Boolean);

        if (selectedMetadata.length > 1) {
            const firstPolicyNumber = selectedMetadata.find(m => m.policyNumber !== undefined)?.policyNumber;
            const firstEffDate = selectedMetadata.find(m => m.policyEffectiveDate !== undefined)?.policyEffectiveDate;
            const firstExpDate = selectedMetadata.find(m => m.policyExpirationDate !== undefined)?.policyExpirationDate;

            for (const meta of selectedMetadata) {
                if (firstPolicyNumber !== undefined && meta.policyNumber !== undefined
                    && meta.policyNumber !== firstPolicyNumber) {
                    return "Selected transactions must match policy #, effective date and expiration date.";
                }
                if (firstEffDate !== undefined && meta.policyEffectiveDate !== undefined
                    && !moment(meta.policyEffectiveDate).isSame(firstEffDate, 'day')) {
                    return "Selected transactions must match policy #, effective date and expiration date.";
                }
                if (firstExpDate !== undefined && meta.policyExpirationDate !== undefined
                    && !moment(meta.policyExpirationDate).isSame(firstExpDate, 'day')) {
                    return "Selected transactions must match policy #, effective date and expiration date.";
                }
            }
        }
        return null;
    };

    const validateMultiApply = (): { valid: boolean; message?: string } => {
        const selectedIds = props.selectedTransactionIds || [];

        if (selectedIds.length === 0) {
            return { valid: false, message: "Please select at least one transaction to apply." };
        }

        if (!props.insuredSummaryId || props.insuredSummaryId === constant.DEFAULT_GUID) {
            return { valid: false, message: "Please select a policy transaction." };
        }

        if (!customerId) {
            return { valid: false, message: "Please select a customer." };
        }

        const metadataList = props.transactionMetadataList || [];

        // RIX is not supported in multi-apply — must be applied individually
        const hasRix = selectedIds.some(id => {
            const meta = metadataList.find(m => m.id === id);
            return meta && meta.cycleBusinessPurposeCode === "RIX";
        });
        if (hasRix) {
            return { valid: false, message: "RIX transactions cannot be applied via multi-apply. Please apply RIX transactions individually." };
        }

        // Only require CS2 policy when no creation type is in the selection
        const hasCreationType = selectedIds.some(id => {
            const meta = metadataList.find(m => m.id === id);
            return meta && CREATION_TYPES.includes(meta.cycleBusinessPurposeCode);
        });
        if (!selectedCS2PolicyId && !hasCreationType) {
            return { valid: false, message: "Please select a policy." };
        }

        const groupError = validateGroupConsistency();
        if (groupError) {
            return { valid: false, message: groupError };
        }

        return { valid: true };
    };

    // Transaction types that can create a customer/policy shell without an existing CS2 policy
    const CREATION_TYPES = ["NBS", "SYN", "REW", "RWL", "PCH", "XLC", "REI"];

    /** Builds the ApplyTransactionDto[] payload for the batch API.
     *  Handles three flows via options:
     *  - Existing customer apply (default): uses customer/policy from component state
     *  - Create customer: createCustomer=true on first item, popup-provided source/company info
     *  - ATMS create: createCustomerFromATMS=true on first item, leadId from ATMS selection
     *  Overrides let callers pass source/company info that isn't in state yet (ATMS auto-apply, popup callbacks). */
    const buildMultiApplyPayload = (options?: {
        sourceId?: string,
        sourceType?: string,
        parentCompanyId?: string,
        writtingCompanyId?: string,
        agencyId?: string,
        createCustomer?: boolean,
        createCustomerFromATMS?: boolean,
        leadId?: string,
        custNo?: string,
    }): ApplyTransactionDto[] => {
        const selectedIds = props.selectedTransactionIds || [];
        const metadataList = props.transactionMetadataList || [];
        const selectedPolicy = transactionSummaryList
            .flatMap(cust => cust.policyReadDTO || [])
            .find(policy => policy.id === selectedCS2PolicyId);

        const isCreateFlow = options?.createCustomer || options?.createCustomerFromATMS;
        const effectiveSourceId = options?.sourceId ?? sourceId;
        const effectiveSourceType = options?.sourceType ?? sourceTypeId;
        const effectiveParentCompanyId = options?.parentCompanyId ?? parentCompanyId;
        const effectiveWrittingCompanyId = options?.writtingCompanyId ?? companyId;
        const effectiveCustNo = options?.custNo ?? selectedCustomerId;

        return selectedIds.map((policyId, index) => {
            const isFirst = index === 0;
            const isCurrentlyViewed = policyId === props.insuredSummaryId;
            const ts = props.transactionSummary;
            const meta = metadataList.find(m => m.id === policyId);
            const txnTypeCode = isCurrentlyViewed ? ts?.cycleBusinessPurposeCode : meta?.cycleBusinessPurposeCode;

            return {
                policyId: policyId,
                transactionType: txnTypeCode,
                transactionTypeCode: txnTypeCode,
                lob: isCurrentlyViewed ? ts?.lineOfBusinessCode : meta?.lineOfBusinessCode,
                seqNum: parseInt(meta?.seqNum || '0', 10),
                transactionDate: meta?.transactionDate,
                custNo: effectiveCustNo,
                sourceId: effectiveSourceId,
                sourceType: effectiveSourceType,
                cs2PolicyId: isCreateFlow ? null : selectedCS2PolicyId,
                cs2PriorPolicyId: isCreateFlow ? null : priorPolicyId,
                cs2CustomerNumber: isCreateFlow ? 0 : selectedCustomerNumber,
                parentCompanyId: effectiveParentCompanyId,
                writtingCompanyId: effectiveWrittingCompanyId,
                agencyId: options?.agencyId ?? null,
                createCustomer: options?.createCustomer ? isFirst : false,
                createCustomerFromATMS: options?.createCustomerFromATMS ? isFirst : false,
                leadId: options?.leadId ?? null,
                // Only for the viewed/edited transaction
                overridenData: isCurrentlyViewed ? {
                    premium: ts?.modifiedPremium,
                    effectiveDate: ts?.modifiedEffectiveDate,
                    polExpDate: ts?.modifiedExpirationDate,
                    mailAddress1: ts?.modifiedMailingAddress1,
                    mailAddress2: ts?.modifiedMailingAddress2,
                    mailCity: ts?.modifiedMailingCity,
                    mailState: ts?.modifiedMailingState,
                    mailZipCode: ts?.modifiedMailingZip,
                    address1: ts?.modifiedPropertyAddress1,
                    address2: ts?.modifiedPropertyAddress2,
                    city: ts?.modifiedPropertyCity,
                    state: ts?.modifiedPropertyState,
                    zipCode: ts?.modifiedPropertyZip
                } : null,
                policyDto: isCurrentlyViewed && selectedPolicy
                    ? { ...selectedPolicy, changedDate: new Date(), enteredDate: new Date() }
                    : null
            };
        });
    };

    /** Executes the multi-apply API call with the given payload. Shared by direct apply and popup callbacks. */
    const executeMultiApply = async (payload: ApplyTransactionDto[]) => {
        try {
            const results = await policyMappingDataService.applyMultiTransaction(payload);
            const success = results.every(r => r.status === "C");
            const transactionsApplied = results.filter(r => r.status === "C").length;
            const totalTransactions = payload.length;

            if (success) {
                toast.success(
                    'Successfully applied all transactions.',
                    { position: toast.POSITION.TOP_RIGHT }
                );
            } else {
                const failedItem = results.find(r => r.status === "E");
                let errorDetail = failedItem?.message
                    ? errorMessageHandler.getCustomErrorMessageForPolicyTransaction(failedItem.message)
                    : '';
                toast.error(
                    `Applied ${transactionsApplied} of ${totalTransactions} transactions. ${errorDetail}`,
                    { position: toast.POSITION.TOP_RIGHT, autoClose: false }
                );
            }

            props.setSelectedTransactionIds?.([]);
            resetState();
            if (props.onStatusChange) props.onStatusChange();
        }
        catch (error) {
            let errorDetail = errorMessageHandler.getCustomErrorMessageForPolicyTransaction(error?.data);
            toast.error(errorDetail, { position: toast.POSITION.TOP_RIGHT });
        }
    };

    const ApplyMultipleTransactions = async () => {
        const validation = validateMultiApply();
        if (!validation.valid) {
            toast.warn(validation.message, { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        // --- CS2 policy validations (mirrors single-apply) ---
        if (selectedCS2PolicyId) {
            const selectedPolicy = transactionSummaryList
                .flatMap(cust => cust.policyReadDTO || [])
                .find(policy => policy.id === selectedCS2PolicyId);

            if (constant.confirmationPolicyTypes.includes(props.transactionSummary.cycleBusinessPurposeCode)) {
                const filteredPolicyList = [...policyList].filter(p => p.policyNumber === selectedPolicy.policyNumber);
                const mostRecentPolicy = [...filteredPolicyList]
                    .sort((a, b) => new Date(b.polEffDate).getTime() - new Date(a.polEffDate).getTime())[0];
                const isSelectedPolicyMostRecent = selectedPolicy && mostRecentPolicy && selectedPolicy.id === mostRecentPolicy.id;
                if (!isSelectedPolicyMostRecent) {
                    setConfirmationLabel(label.UnmatchedPolicy.POLICY_TRANSACTION_APPLY_NOT_LATEST);
                    const userConfirmed = await showConfirmModal();
                    if (!userConfirmed) return;
                }
            } else {
                if (props.transactionSummary.policyNumber != selectedPolicy.policyNumber) {
                    toast.warn("Policy Number Does Not Match", { position: toast.POSITION.TOP_RIGHT });
                    return;
                }
                if (!moment(props.transactionSummary.policyEffectiveDate).isSame(selectedPolicy.polEffDate, 'day')) {
                    setConfirmationLabel(label.UnmatchedPolicy.POLICY_TRANSACTION_APPLY_MISMATCH);
                    const userConfirmed = await showConfirmModal();
                    if (!userConfirmed) return;
                }
            }
        }

        // --- Source/company info check — show popup if any info is missing ---
        const needsSourceLookup = sourceId === null || sourceTypeId === null
            || parentCompanyId === null || companyId === null;

        if (needsSourceLookup) {
            const customerSearch: CustomerSearch = { policyNumber: props.transactionSummary.policyNumber };
            var customerList = await policyMappingDataService.fetchAtsmsCustomerList(customerSearch);

            if ((customerList.data.length === 0 || customerList.data.length > 1)
                || (customerList.data.length === 1 && (customerList.data[0]?.sourceId === null || customerList.data[0]?.sourceTypeId === null))) {
                // Show popup to collect missing info — popup callback handles the rest
                let firstName = BreakInsuredName().firstName, lastName = BreakInsuredName().lastName, middleName = BreakInsuredName().middleName;
                setApplyPopupData({
                    firstName, lastName, middleName, agencyId,
                    parentCompany: selectedCS2PolicyId ? parentCompanyId : props.transactionSummary.parentCompanyId,
                    writtingCompany: selectedCS2PolicyId ? companyId : props.transactionSummary.companyId,
                    showCompanyInfo: parentCompanyId === null || companyId === null
                });
                setShowApplyPolicyPopup(true);
                return;
            } else {
                // ATMS found unique match — use source info directly and proceed
                setSourceId(customerList.data[0].sourceId);
                setSourceTypeId(customerList.data[0].sourceTypeId);
                const payload = buildMultiApplyPayload({
                    sourceId: customerList.data[0].sourceId,
                    sourceType: customerList.data[0].sourceTypeId
                });
                await executeMultiApply(payload);
                return;
            }
        }

        // --- Direct apply (source info already available) ---
        const payload = buildMultiApplyPayload();
        await executeMultiApply(payload);
    };

    /** Routes to multi-apply or single-apply based on checkbox selection */
    const handleApplyClick = async () => {
        if (props.selectedTransactionIds?.length > 1) {
            await ApplyMultipleTransactions();
        } else {
            await ApplyTransaction();
        }
    };

    const ApplyTransaction = async () => {

        // If NBS transaction is not selected, then check props.insuredSummaryId and selectedCS2PolicyId
        // If transaction is RWL then check for prior policy
        // If transaction is NBS then check for customerId

        if (selectedCS2PolicyId) {

            const selectedPolicy = transactionSummaryList
                .flatMap(cust => cust.policyReadDTO || [])
                .find(policy => policy.id === selectedCS2PolicyId);


            if (constant.confirmationPolicyTypes.includes(props.transactionSummary.cycleBusinessPurposeCode)) {
                if (props.transactionSummary.cycleBusinessPurposeCode === "RIX"
                    && props.transactionSummary.policyNumber != selectedPolicy.policyNumber) {
                    setConfirmationLabel(label.UnmatchedPolicy.POLICY_TRANSACTION_APPLY_POLICY_NUMBER_MISMATCH);
                    const userConfirmed = await showConfirmModal();
                    if (!userConfirmed) {
                        return false;
                    }
                }

                const filteredPolicyList = [...policyList].filter(p => p.policyNumber ===selectedPolicy.policyNumber);
                const mostRecentPolicy = [...filteredPolicyList]
                    .sort((a, b) => new Date(b.polEffDate).getTime() - new Date(a.polEffDate).getTime())[0];

                const isSelectedPolicyMostRecent = selectedPolicy && mostRecentPolicy && selectedPolicy.id === mostRecentPolicy.id;
              
                if (!isSelectedPolicyMostRecent) {
                    setConfirmationLabel(label.UnmatchedPolicy.POLICY_TRANSACTION_APPLY_NOT_LATEST);
                    const userConfirmed = await showConfirmModal();
                    if (!userConfirmed) {
                        return false;
                    }
                }
            }
            else {
                if (props.transactionSummary.policyNumber != selectedPolicy.policyNumber) {
                    toast.warn("Policy Number Does Not Match", {
                        position: toast.POSITION.TOP_RIGHT
                    });
                    return false;
                } else {

                    if (!moment(props.transactionSummary.policyEffectiveDate).isSame(selectedPolicy.polEffDate, 'day')
                    ) {
                        setConfirmationLabel(label.UnmatchedPolicy.POLICY_TRANSACTION_APPLY_MISMATCH);
                        const userConfirmed = await showConfirmModal();
                        if (!userConfirmed) {
                            return false; // true if Yes, false if No
                        }
                    }
                }
            }
        }
        if (!props.insuredSummaryId || props.insuredSummaryId === constant.DEFAULT_GUID) {
            toast.warn("Please select a policy transaction.", {
                position: toast.POSITION.TOP_RIGHT
            });
            return false;
        }
        if (!customerId) {
            toast.warn("Please select a customer.", {
                position: toast.POSITION.TOP_RIGHT
            });
            return false;
        }

        const customerSearch: CustomerSearch = {
            policyNumber: props.transactionSummary.policyNumber,
        };
        if (props.transactionSummary.cycleBusinessPurposeCode === "NBS"
            || (props.transactionSummary.cycleBusinessPurposeCode !== "NBS"
                && (sourceId === null || sourceTypeId === null
                    ||
                    (isShowCompanyInfoType(props.transactionSummary.cycleBusinessPurposeCode) &&
                    (parentCompanyId === null || companyId === null)

                ))))
            {
            var customerList = await policyMappingDataService.fetchAtsmsCustomerList(customerSearch);
            if ((customerList.data.length === 0 || customerList.data.length > 1) || (customerList.data.length === 1 && (customerList.data[0]?.sourceId === null || customerList.data[0]?.sourceTypeId === null))) {
                let firstName = BreakInsuredName().firstName, lastName = BreakInsuredName().lastName, middleName = BreakInsuredName().middleName;

                setApplyPopupData({
                    firstName,
                    lastName,
                    middleName,
                    agencyId,
                    parentCompany: isShowCompanyInfoType(props.transactionSummary.cycleBusinessPurposeCode) ? props.transactionSummary.parentCompanyId : parentCompanyId,
                    writtingCompany: isShowCompanyInfoType(props.transactionSummary.cycleBusinessPurposeCode) ? props.transactionSummary.companyId : companyId,
                    showCompanyInfo : isShowCompanyInfoType(props.transactionSummary.cycleBusinessPurposeCode)
                });

                setShowApplyPolicyPopup(true);
            }
            else {
                setSourceId(customerList.data[0].sourceId);
                setSourceTypeId(customerList.data[0].sourceTypeId);
                if (isShellApplyRequired()) {
                    var shellDto = buildShellDto(customerList.data[0].sourceId, customerList.data[0].sourceTypeId, parentCompanyId, companyId);
                    var shellResponse = await policyMappingDataService.applyShellPolicyTransaction(shellDto);
                    toast.success(shellResponse, { position: toast.POSITION.TOP_RIGHT });
                } else {
                    const selectedPolicy = transactionSummaryList
                    .flatMap(cust => cust.policyReadDTO || [])
                    .find(policy => policy.id === selectedCS2PolicyId);
                    var policyTransaction = await policyMappingDataService.applyPolicyTransaction(props.transactionSummary, selectedCustomerId, customerList.data[0].sourceId, customerList.data[0].sourceTypeId, selectedCS2PolicyId, priorPolicyId, selectedCustomerNumber, parentCompanyId, companyId,selectedPolicy);
                    toast.success(policyTransaction, { position: toast.POSITION.TOP_RIGHT });
                }
                resetState()
                handleApplySuccess();
            }
        }
        else if (props.transactionSummary.cycleBusinessPurposeCode === "SYN"
            || (props.transactionSummary.cycleBusinessPurposeCode !== "SYN" 
                && (sourceId === null || sourceTypeId === null 
                    ||  
                    (isShowCompanyInfoType(props.transactionSummary.cycleBusinessPurposeCode) &&
                    (parentCompanyId === null || companyId === null)
                
                ))))
            {
            var customerList = await policyMappingDataService.fetchAtsmsCustomerList(customerSearch);
            if ((customerList.data.length === 0 || customerList.data.length > 1) || (customerList.data.length === 1 && (customerList.data[0]?.sourceId === null || customerList.data[0]?.sourceTypeId === null))) {
                let firstName = BreakInsuredName().firstName, lastName = BreakInsuredName().lastName, middleName = BreakInsuredName().middleName;
                
                setApplyPopupData({ 
                    firstName, 
                    lastName, 
                    middleName, 
                    agencyId, 
                    parentCompany: props.transactionSummary.cycleBusinessPurposeCode === "SYN" ? props.transactionSummary.parentCompanyId : parentCompanyId, 
                    writtingCompany: props.transactionSummary.cycleBusinessPurposeCode === "SYN" ? props.transactionSummary.companyId : companyId, 
                    showCompanyInfo : isShowCompanyInfoType(props.transactionSummary.cycleBusinessPurposeCode)  
                });
               
                setShowApplyPolicyPopup(true);
            }
            else {
                setSourceId(customerList.data[0].sourceId);
                setSourceTypeId(customerList.data[0].sourceTypeId);
                const selectedPolicy = transactionSummaryList
                .flatMap(cust => cust.policyReadDTO || [])
                .find(policy => policy.id === selectedCS2PolicyId);
                var policyTransaction = await policyMappingDataService.applyPolicyTransaction(props.transactionSummary, selectedCustomerId, customerList.data[0].sourceId, customerList.data[0].sourceTypeId, selectedCS2PolicyId, priorPolicyId, selectedCustomerNumber, parentCompanyId, companyId,selectedPolicy);
                toast.success(policyTransaction, {
                    position: toast.POSITION.TOP_RIGHT
                });
                resetState()
                handleApplySuccess();
            }
        }
        else {
            try {
                if (isShellApplyRequired()) {
                    var shellDto = buildShellDto(sourceId, sourceTypeId, parentCompanyId, companyId);
                    var shellResponse = await policyMappingDataService.applyShellPolicyTransaction(shellDto);
                    toast.success(shellResponse, { position: toast.POSITION.TOP_RIGHT });
                } else {
                    const selectedPolicy = transactionSummaryList
                    .flatMap(cust => cust.policyReadDTO || [])
                    .find(policy => policy.id === selectedCS2PolicyId);
                    var policyTransaction = await policyMappingDataService.applyPolicyTransaction(props.transactionSummary, selectedCustomerId, sourceId, sourceTypeId, selectedCS2PolicyId, priorPolicyId, selectedCustomerNumber, parentCompanyId, companyId, selectedPolicy);
                    toast.success(policyTransaction, { position: toast.POSITION.TOP_RIGHT });
                }
                resetState()
                handleApplySuccess();
            }
            catch (error) {
                let errorDetail = errorMessageHandler.getCustomErrorMessageForPolicyTransaction(error?.data);
                toast.error(errorDetail, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        }
    }

    // Clear advanced search and reset quick search when policy changes
    useEffect(() => {
        setAdvancedSearchRows([]);
        setHasSearched(false);
    }, [props.transactionSummary]);

    useEffect(() => {
        if (props.isNewCustomerLoad) {
            isFirstNameSearch(false);
            isAddressSearch(false);
            isPolicyNumberSearch(false);
        }
        if (props.isNewCarrerLoad) {
            islastNameSearch(false)
        }
        setTransactionSummaryList(props.transactionSummaryData)
        setAtmsCustomerList(props.atmCustomerData)
        setAtmsLeadId('');
        setAtmsSelectedRowId(null);
        if ((props.transactionSummaryData !== undefined && props.transactionSummaryData.length > 0) || (props.atmCustomerData !== undefined && props.atmCustomerData.length > 0)) {
            islastNameSearch(true)
            setPolicyOpen(false);
        }
        else {
            setPolicyOpen(false);
        }
       resetState();
    }, [props.transactionSummaryData, props.atmCustomerData]);


    const BreakInsuredName = () => {
        let firstName = '', middleName = '', lastName = '';
        if (props.transactionSummary && props.transactionSummary.insuredsName) {
            const nameParts = props.transactionSummary.insuredsName.trim().split(' ');
            if (nameParts.length === 1) {
                firstName = nameParts[0];
            } else if (nameParts.length === 2) {
                firstName = nameParts[0];
                lastName = nameParts[1];
            } else if (nameParts.length >= 3) {
                firstName = nameParts[0];
                middleName = nameParts.slice(1, -1).join(' ');
                lastName = nameParts[nameParts.length - 1];
            }
        }
        return { firstName, middleName, lastName };
    }

    const normalizePolicyNumberForSearch = (policyNumber: string) => {
        const lastHyphenIndex = policyNumber.lastIndexOf('-');
        const hyphenCount = (policyNumber.match(/-/g) || []).length;
        return hyphenCount > 1 ? policyNumber.substring(0, lastHyphenIndex) : policyNumber;
    };

    const ReFilterTransactionSummaryList = () => {
        setPolicyOpen(false);
        setOpen(false);
        // Build CustomerSearch object for quick search
        let addressValue = '';
        if (addressSearch && props.transactionSummary && props.transactionSummary.streetAddressLine1) {
            // Quick search: use only first 5 chars, trimmed
            addressValue = props.transactionSummary.streetAddressLine1.trim().substring(0, 5).trim();
        }

        const customerSearch: CustomerSearch = {
            firstName: firstNameSearch && props.insuredNameArray ? props.insuredNameArray[0] : '',
            lastName: lastNameSearch && props.insuredNameArray ? props.insuredNameArray[props.insuredNameArray.length - 1] : '',
            address1: addressValue,
            policyNumber: policyNumberSearch && props.transactionSummary ? normalizePolicyNumberForSearch(props.transactionSummary.policyNumber) : '',
        };
        if (activeTab === 'tab1') {
            props.GetTransactionSummaryList(customerSearch);
        }
        if (activeTab === 'tab2') {
            props.GetCustomerFromATMSList(customerSearch);
        }
        resetState();
    }

    // Only run tab change logic when activeTab changes
    useEffect(() => {
        // If advanced search is active, repeat advanced search on tab change
        if (advancedSearchRows.length > 0 && advancedSearchRows.every(r => r.value && r.value.trim())) {
            const filterObject = {};
            advancedSearchRows.forEach(r => {
                filterObject[r.type] = r.value;
            });
            handleAdvancedSearch(filterObject);
        } else {
            ReFilterTransactionSummaryList();
        }
    }, [activeTab]);

    // Run quick search logic only when quick search toggles change (not on tab change)
    useEffect(() => {
        if (advancedSearchRows.length === 0 && !props.isNewCustomerLoad) {
            ReFilterTransactionSummaryList();
        }
    }, [firstNameSearch, addressSearch, policyNumberSearch]);

    var dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
    var timeOptions = { hour: 'numeric', minute: 'numeric', hour12: true };

    const handleCreateCustomerAndApply = () => {
        // const isMultiApply = (props.selectedTransactionIds?.length || 0) > 1;

        if (!props.insuredSummaryId || props.insuredSummaryId === constant.DEFAULT_GUID) {
            toast.warn("Please select a policy transaction.", {
                position: toast.POSITION.TOP_RIGHT
            });
            return;
        }

        // Multi-apply customer creation — commented out for now
        // if (isMultiApply) {
        //     const metadataList = props.transactionMetadataList || [];
        //     const hasAllowed = props.selectedTransactionIds.some(id => {
        //         const meta = metadataList.find(m => m.id === id);
        //         return meta && CREATION_TYPES.includes(meta.cycleBusinessPurposeCode);
        //     });
        //     if (!hasAllowed) {
        //         toast.warn("Selected transaction type is not supported for customer creation.", {
        //             position: toast.POSITION.TOP_RIGHT
        //         });
        //         return;
        //     }
        //     const groupError = validateGroupConsistency();
        //     if (groupError) {
        //         toast.warn(groupError, { position: toast.POSITION.TOP_RIGHT });
        //         return;
        //     }
        // } else {
            // Existing single-apply check
            if (!CUSTOMER_CREATION_TYPES.includes(props.transactionSummary.cycleBusinessPurposeCode)) {
                toast.warn("Transaction not allowed.", {
                    position: toast.POSITION.TOP_RIGHT
                });
                return;
            }
        // }

        let firstName = '', middleName = '', lastName = '';
        if (props.transactionSummary && props.transactionSummary.insuredsName) {
            const nameParts = props.transactionSummary.insuredsName.trim().split(' ');
            if (nameParts.length === 1) {
                firstName = nameParts[0];
            } else if (nameParts.length === 2) {
                firstName = nameParts[0];
                lastName = nameParts[1];
            } else if (nameParts.length >= 3) {
                firstName = nameParts[0];
                middleName = nameParts.slice(1, -1).join(' ');
                lastName = nameParts[nameParts.length - 1];
            }
        }

        setPopupData({ firstName, lastName, middleName, parentCompany: props.transactionSummary.parentCompanyId, writtingCompany: props.transactionSummary.companyId });
        setShowCreateCustomerPopup(true);
    };

    const fetchSourceTypes = async () => {
        const sources = await policyMappingDataService.getSourceTypes();
        setSourcesTypeList(sources);
    };
    const fetchAgencies = async () => {
        const agencies = await policyMappingDataService.getAgencies();
        setAgencyList(agencies);
    }

    const handleCreateCustomerFromAtmsAndApplyTransaction = async () => {
        // const isMultiApply = (props.selectedTransactionIds?.length || 0) > 1;

        if (!props.insuredSummaryId || props.insuredSummaryId === constant.DEFAULT_GUID) {
            toast.warn("Please select a policy transaction.", {
                position: toast.POSITION.TOP_RIGHT
            });
            return;
        }
        if (!atmsLeadId || atmsLeadId.trim() === '') {
            toast.warn("Please select a ATMS customer.", {
                position: toast.POSITION.TOP_RIGHT
            });
            return;
        }

        // Multi-apply ATMS customer creation — commented out for now
        // if (isMultiApply) {
        //     const metadataList = props.transactionMetadataList || [];
        //     const hasAllowed = props.selectedTransactionIds.some(id => {
        //         const meta = metadataList.find(m => m.id === id);
        //         return meta && CREATION_TYPES.includes(meta.cycleBusinessPurposeCode);
        //     });
        //     if (!hasAllowed) {
        //         toast.warn("Selected transaction type is not supported for customer creation.", {
        //             position: toast.POSITION.TOP_RIGHT
        //         });
        //         return;
        //     }
        //     const groupError = validateGroupConsistency();
        //     if (groupError) {
        //         toast.warn(groupError, { position: toast.POSITION.TOP_RIGHT });
        //         return;
        //     }
        //     const payload = buildMultiApplyPayload({
        //         createCustomerFromATMS: true,
        //         leadId: atmsLeadId,
        //         custNo: '',
        //     });
        //     setAtmsLeadId('');
        //     setAtmsSelectedRowId(null);
        //     await executeMultiApply(payload);
        // } else {
            // Existing single-apply flow
            if (!CUSTOMER_CREATION_TYPES.includes(props.transactionSummary.cycleBusinessPurposeCode)) {
                toast.warn("Transaction not allowed.", {
                    position: toast.POSITION.TOP_RIGHT
                });
                return;
            }
            try {
                if (SHELL_TRANSACTION_TYPES.includes(props.transactionSummary.cycleBusinessPurposeCode)) {
                    var shellDto = buildShellDto(null, null, null, null, { isLeadFound: true, leadId: atmsLeadId });
                    var shellResponse = await policyMappingDataService.applyShellPolicyTransaction(shellDto);
                    setAtmsLeadId('');
                    setAtmsSelectedRowId(null);
                    toast.success(shellResponse, { position: toast.POSITION.TOP_RIGHT });
                    handleApplySuccess();
                } else {
                    var response = await policyMappingDataService.createCustomerFromAtmsAndApplyTransaction(
                        props.insuredSummaryId,
                        atmsLeadId,
                        props.transactionSummary.cycleBusinessPurposeCode,
                        props.transactionSummary.lineOfBusinessCode
                    );
                    setAtmsLeadId('');
                    setAtmsSelectedRowId(null);
                    if (response) {
                        toast.success('Customer created and policy applied!', { position: toast.POSITION.TOP_RIGHT });
                        handleApplySuccess();
                    }
                    else {
                        toast.error('Failed to create customer/apply policy', { position: toast.POSITION.TOP_RIGHT });
                    }
                }
            } catch (error) {
               let errorDetail = errorMessageHandler.getCustomErrorMessageForPolicyTransaction(error?.data);
                toast.error(errorDetail, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        // }
    };

    useEffect(() => {
        fetchSourceTypes();
        fetchAgencies();
    }, []);

    const handleCreateCustomerAndApplySave = async (selectedAgency, selectedSourceType, selectedSource, selectedParentCompany, selectedWrittingCompany) => {
        // Multi-apply customer creation — commented out for now
        // const isMultiApply = (props.selectedTransactionIds?.length || 0) > 1;
        // if (isMultiApply) {
        //     const payload = buildMultiApplyPayload({
        //         createCustomer: true,
        //         custNo: '',
        //         sourceId: selectedSource,
        //         sourceType: selectedSourceType,
        //         agencyId: selectedAgency,
        //         parentCompanyId: selectedParentCompany,
        //         writtingCompanyId: selectedWrittingCompany,
        //     });
        //     setShowCreateCustomerPopup(false);
        //     await executeMultiApply(payload);
        // } else {
            // Existing single-apply create customer flow
            try {
                if (SHELL_TRANSACTION_TYPES.includes(props.transactionSummary.cycleBusinessPurposeCode)) {
                    var shellDto = buildShellDto(selectedSource, selectedSourceType, selectedParentCompany, selectedWrittingCompany, { createCustomer: true, agencyId: selectedAgency });
                    var shellResponse = await policyMappingDataService.applyShellPolicyTransaction(shellDto);
                    setShowCreateCustomerPopup(false);
                    toast.success(shellResponse, { position: toast.POSITION.TOP_RIGHT });
                } else {
                    var response = await policyMappingDataService.createCustomerAndApply(
                        props.insuredSummaryId,
                        selectedAgency,
                        selectedSourceType,
                        selectedSource,
                        props.transactionSummary.cycleBusinessPurposeCode,
                        props.transactionSummary.lineOfBusinessCode,
                        selectedParentCompany,
                        selectedWrittingCompany,
                    );
                    setShowCreateCustomerPopup(false);
                    toast.success('Customer created and policy applied!', { position: toast.POSITION.TOP_RIGHT });
                }
                handleApplySuccess();
            } catch (error) {
                let errorDetail = errorMessageHandler.getCustomErrorMessageForPolicyTransaction(error?.data);
                toast.error(errorDetail, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        // }
    };

    const handleApplyPolicyandSave = async (selectedAgency, selectedSourceType, selectedSource, selectedParentCompany, selectedWrittingCompany) => {
        const isMultiApply = (props.selectedTransactionIds?.length || 0) > 1;

        if (isMultiApply) {
            const payload = buildMultiApplyPayload({
                sourceId: selectedSource,
                sourceType: selectedSourceType,
                parentCompanyId: selectedParentCompany,
                writtingCompanyId: selectedWrittingCompany
            });
            setShowApplyPolicyPopup(false);
            await executeMultiApply(payload);
        } else {
            // Existing single-apply flow
            try {
                if (isShellApplyRequired()) {
                    var shellDto = buildShellDto(selectedSource, selectedSourceType, selectedParentCompany, selectedWrittingCompany);
                    var shellResponse = await policyMappingDataService.applyShellPolicyTransaction(shellDto);
                    setShowApplyPolicyPopup(false);
                    toast.success(shellResponse, { position: toast.POSITION.TOP_RIGHT });
                } else {
                    const selectedPolicy = transactionSummaryList
                        .flatMap(cust => cust.policyReadDTO || [])
                        .find(policy => policy.id === selectedCS2PolicyId);
                    var policyTransaction = await policyMappingDataService.applyPolicyTransaction(
                        props.transactionSummary,
                        selectedCustomerId,
                        selectedSource,
                        selectedSourceType,
                        selectedCS2PolicyId,
                        priorPolicyId,
                        selectedCustomerNumber,
                        selectedParentCompany,
                        selectedWrittingCompany,
                        selectedPolicy
                    );
                    setShowApplyPolicyPopup(false);
                    toast.success(policyTransaction, { position: toast.POSITION.TOP_RIGHT });
                }
                resetState();
                handleApplySuccess();
            }
            catch (error) {
                let errorDetail = errorMessageHandler.getCustomErrorMessageForPolicyTransaction(error?.data);
                toast.error(errorDetail, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        }
    };

    const handleTabChange = (tab: string) => {
        setActiveTab(tab);
        setAtmsLeadId('');
        setAtmsSelectedRowId(null);
    };

    useEffect(() => {
        setActiveTab(props.defaultSelectedTab || constant.UnMatchedPolicy.tab1);
    }, [props.defaultSelectedTab]);

    const handleAtmsLeadSelection = (leadId: string) => {
        setAtmsLeadId(leadId);
        setAtmsSelectedRowId(leadId)
    };


    /// Customer Advance Search

    const filterOptions = useMemo(() => [
        { value: 'firstName', label: 'First name', allowedChars: 'a-zA-Z ,.-', allowedSpace: true },
        { value: 'lastName', label: 'Last name', allowedChars: 'a-zA-Z ,.-', allowedSpace: true },
        { value: 'policyNumber', label: 'Policy number', minLength: 3, maxLength: 25, allowedChars: 'a-zA-Z0-9-_ ', allowedSpace: true },
        { value: 'accountNumber', label: 'Account/Reference number', maxLength: 25, allowedChars: '0-9', allowedSpace: false },
        { value: 'address1', label: 'Address', maxLength: 100, allowedChars: 'a-zA-Z0-9 ,.', allowedSpace: true },
        { value: 'city', label: 'City', maxLength: 50, allowedChars: 'a-zA-Z ', allowedSpace: true },
        { value: 'state', label: 'State', maxLength: 50, allowedChars: 'a-zA-Z', allowedSpace: true },
        { value: 'zip', label: 'Zip', maxLength: 10, allowedChars: 'a-zA-Z0-9-', allowedSpace: false },
        { value: 'email', label: 'Email', maxLength: 100, allowedChars: 'a-zA-Z0-9@._-', allowedSpace: false },
        { value: 'locationAddress', label: 'Location address (Property Address)', maxLength: 100, allowedChars: 'a-zA-Z0-9 ,.', allowedSpace: true },
        { value: 'phoneNumber', label: 'Phone Number', maxLength: 10, allowedChars: '0-9', allowedSpace: false },
    ], []);

    // Handles advanced search
    const handleAdvancedSearch = (filterObj: { [key: string]: string }) => {
        setPolicyOpen(false);
        setOpen(false);
        Object.keys(filterObj).forEach((key) => {
            filterObj[key] = filterObj[key].trim();
        });

        let hasError = false;
        const updatedAdvancedSearchRows = advancedSearchRows.map((row) => {
            if (row.type === 'accountNumber') {
                if (activeTab === 'tab1' && !/^\d+$/.test(row.value)) {
                    hasError = true;
                    return { ...row, error: 'Account number must be numeric.' };
                }
                if (activeTab === 'tab2' && !/^[a-zA-Z0-9]+$/.test(row.value)) {
                    hasError = true;
                    return { ...row, error: 'Reference number must be alphanumeric' };
                }
            }
            return { ...row, error: '' }; // Clear error if validation passes
        });

        setAdvancedSearchRows(updatedAdvancedSearchRows);

        if (hasError) {
            return; // Stop execution if there are validation errors
        }

        // Advanced search: use full trimmed input for address
        const customerSearch: CustomerSearch = {
            firstName: filterObj.firstName || '',
            lastName: filterObj.lastName || '',
            policyNumber: filterObj.policyNumber || '',
            address1: filterObj.address1 ? filterObj.address1.trim() : '',
            city: filterObj.city || '',
            state: filterObj.state || '',
            zip: filterObj.zip ? filterObj.zip.replaceAll('-', '').trim() : '',
            email: filterObj.email || '',
            locationAddress: filterObj.locationAddress || '',
            phoneNumber: filterObj.phoneNumber || '',
            accountNumber: activeTab === 'tab1' ? filterObj.accountNumber || '' : undefined,
            referenceNbr: activeTab === 'tab2' ? filterObj.accountNumber || '' : undefined,
        };

        setHasSearched(true);
        if (activeTab === 'tab1') {
            props.GetTransactionSummaryList(customerSearch);
        }
        if (activeTab === 'tab2') {
            props.GetCustomerFromATMSList(customerSearch);
        }
    }


    const selectedTypes = useMemo(() => advancedSearchRows.map(r => r.type), [advancedSearchRows]);
    const firstAvailableType = useMemo(() => filterOptions.find(opt => !selectedTypes.includes(opt.value))?.value || filterOptions[0].value, [filterOptions, selectedTypes]);

    const handleAdd = useCallback(() => {
        setAdvancedSearchRows(rows => [
            ...rows,
            { id: nextAdvancedRowId, type: firstAvailableType, value: '', error: '' }
        ]);
        setNextAdvancedRowId(id => id + 1);
    }, [firstAvailableType]);

    const renderQuickSearchRow = () => {
        return renderQuickSearchButtons({
            firstNameSearch,
            lastNameSearch,
            addressSearch,
            policyNumberSearch,
            advancedSearchRows,
            props,
            handleAdd,
            filterOptions,
            firstAvailableType
        });
    };


        const renderQuickSearchButtons = ({ firstNameSearch, lastNameSearch, addressSearch, policyNumberSearch, advancedSearchRows, props, handleAdd, filterOptions, firstAvailableType }) => (
        <div className="quick-search-container">
            <div className="quick-search-buttons-row">
                <div className="quick-search-buttons-group">
                    
                    <Button 
                        className={`btn-badge btn-badge--priority-${firstNameSearch ? 'clicked' : 'notclicked'} quick-search-button`}
                        onClick={() => { props.setNewCustomerLoad(false); props.insuredNameArray !== undefined ? isFirstNameSearch(!firstNameSearch) : isFirstNameSearch(false) }}
                        disabled={advancedSearchRows.length > 0 || !props.hasUIComponentReadAccess}
                    >
                        {props.insuredNameArray === undefined ? "" : props.insuredNameArray[0]} 
                    </Button>
                    
                    <Button 
                        className={`btn-badge btn-badge--priority-${lastNameSearch ? 'clicked' : 'notclicked'} quick-search-button`}
                        onClick={() => props.insuredNameArray !== undefined ? islastNameSearch(true) : islastNameSearch(false)}
                        disabled={advancedSearchRows.length > 0 || !props.hasUIComponentReadAccess}
                    >
                        {props.insuredNameArray === undefined ? "" : props.insuredNameArray[props.insuredNameArray.length - 1]}
                    </Button>
                    
                    <Button 
                        className={`btn-badge-a btn-badge--priority-${addressSearch ? 'clicked' : 'notclicked'} quick-search-button`}
                        onClick={() => { props.setNewCustomerLoad(false); props.insuredNameArray !== undefined ? isAddressSearch(!addressSearch) : isAddressSearch(false) }}
                        disabled={advancedSearchRows.length > 0 || !props.hasUIComponentReadAccess}
                    >
                        {props.insuredNameArray === undefined ? "" : props.transactionSummary.streetAddressLine1}
                    </Button>
                    
                    <Button 
                        className={`btn-badge-a btn-badge--priority-${policyNumberSearch ? 'clicked' : 'notclicked'} quick-search-button`}
                        onClick={() => { props.setNewCustomerLoad(false); props.transactionSummary?.policyNumber ? isPolicyNumberSearch(!policyNumberSearch) : isPolicyNumberSearch(false) }}
                        disabled={advancedSearchRows.length > 0 || !props.hasUIComponentReadAccess}
                    >
                        {props.transactionSummary?.policyNumber === undefined ? "" : props.transactionSummary?.policyNumber}
                    </Button>
                </div>
                
                <div className="add-button-container">
                    <Button 
                        variant="danger" 
                        className="btn-icon" 
                        onClick={handleAdd}
                        disabled={(advancedSearchRows.length >= filterOptions.length || !props.insuredSummaryId || props.insuredSummaryId === constant.DEFAULT_GUID) || !props.hasUIComponentReadAccess}
                    >
                        ADD
                    </Button>
                </div>
            </div>
        </div>
    );

    const renderAdvancedSearchRows = () => {
        const selectedTypes = advancedSearchRows.map(r => r.type);
        return (
            <div className="advanced-search-container">
                {/* Field labels row */}
                <Row className="pb-1 advanced-search-header">
                    <Column lg={3} className="advanced-search-header-column">Search By:</Column>
                    <Column lg={5} className="advanced-search-header-column">Search Value</Column>
                </Row>
                {advancedSearchRows.map((row, idx) => renderAdvancedSearchRow(row, selectedTypes))}
                {renderAdvancedSearchActions(handleAdvancedSearchClick, handleClear)}
            </div>
        );
    };

    const handleClear = () => {
        setAdvancedSearchRows([]);
        isFirstNameSearch(false);
        isAddressSearch(false);
        isPolicyNumberSearch(false);
        islastNameSearch(true);
        if (hasSearched) {
            ReFilterTransactionSummaryList();
        }
        setHasSearched(false);
    };


    const renderAdvancedSearchRow = (row, selectedTypes) => {

        const fieldConfig = filterOptions.find(opt => opt.value === row.type);

        return (
        <Row key={row.id} className="pb-2" style={{ marginBottom: 0 }}>
            <Column lg={3}>
                <select className="form-select" value={row.type} onChange={e => {
                    const newType = e.target.value;
                    if (selectedTypes.includes(newType) && newType !== row.type) return;
                    setAdvancedSearchRows(rows => rows.map(r => r.id === row.id ? { ...r, type: newType, value: '', error: '' } : r));
                }}>
                    {filterOptions.map(opt => (
                        <option key={opt.value} value={opt.value} disabled={selectedTypes.includes(opt.value) && row.type !== opt.value}>
                            {opt.label}
                        </option>
                    ))}
                </select>
            </Column>
            <Column lg={5}>
                {row.type === 'state' ? (
                    <Select
                        id={`advanced-search-state-${row.id}`}
                        controlId={`advanced-search-state-${row.id}`}
                        label="Select state"
                        options={usStates}
                        defaultSelected={usStates.filter(option => option.value === row.value)}
                        onChange={(values) => {
                            const selectedState = (values[0] as string) || '';
                            setAdvancedSearchRows(rows =>
                                rows.map(r => (r.id === row.id ? { ...r, value: selectedState, error: '' } : r))
                            );
                        }}
                        showAsFloatingLabel={false}
                    />
                ) : (
                    <input
                        className="form-control"
                        type="text"
                        value={row.value}
                        onBlur={() => {
                            if (row.type === 'policyNumber') {
                                const normalizedValue = normalizePolicyNumberInput(row.value, true);
                                setAdvancedSearchRows(rows =>
                                    rows.map(r => (r.id === row.id ? { ...r, value: normalizedValue } : r))
                                );
                            }
                        }}
                        onChange={(e) => {
                                const sanitizedValue = handleInputChange(e.target.value, fieldConfig);
                                setAdvancedSearchRows(rows =>
                                    rows.map(r => (r.id === row.id ? { ...r, value: sanitizedValue } : r))
                                );
                            }}
                        placeholder={row.type === 'address1' ? 'Address' : `Enter ${row.type.replace(/([A-Z])/g, ' $1')}`}
                    />
                )}
                {row.error && <div style={{ color: 'red', fontSize: 12 }}>{row.error}</div>}
            </Column>
            <Column lg={2}>
                <Button variant="outline-danger" onClick={() => {
                    const updatedRows = advancedSearchRows.filter(r => r.id !== row.id);
                    setAdvancedSearchRows(updatedRows);
                    if (updatedRows.length === 0) {

                        isFirstNameSearch(false);
                        isAddressSearch(false);
                        isPolicyNumberSearch(false);
                        islastNameSearch(true);
                        if (hasSearched) {
                            ReFilterTransactionSummaryList();
                        }
                        setHasSearched(false);
                    }
                }}>
                    Remove
                </Button>
            </Column>
        </Row>
    )};


    const renderAdvancedSearchActions = (onSearch, onClear) => {

        const isSearchDisabled = advancedSearchRows.length === 0 || advancedSearchRows.some(r => {
            const value = r.value.trim();
            return !value || (r.type === 'policyNumber' && value.length < 3);
        });
        return (
            <Row>
                <Column lg={{ span: 3, offset: 9 }} className="text-end">
                    <Button variant="primary" onClick={onSearch} disabled={isSearchDisabled}>
                        Search
                    </Button>
                    <Button variant="outline-danger" className="ms-2" onClick={onClear}>
                        Clear
                    </Button>
                </Column>
            </Row>
        );
    };


    const handleAdvancedSearchClick = () => {
        let hasError = false;
        setAdvancedSearchRows(rows => rows.map(r => {
            if (!r.value.trim()) {
                hasError = true;
                return { ...r, error: 'Please enter a value.' };
            }
            if (r.type === 'phoneNumber' && r.value.length !== 10) {
                hasError = true;
                return { ...r, error: 'Phone number must be 10 digits.' };
            }
            if (r.type === 'policyNumber' && r.value.trim().length < 3) {
                hasError = true;
                return { ...r, error: 'Policy number must be at least 3 characters.' };
            }
            return { ...r, error: '' };
        }));
        if (hasError) return;
        const filterObject = {};
        advancedSearchRows.forEach(r => {
            filterObject[r.type] = r.value;
        });
        handleAdvancedSearch(filterObject);
    };

    const normalizePolicyNumberInput = (value: string, trimTrailing = false) => {
        // Remove leading spaces and collapse consecutive spaces: "  ABC   123" -> "ABC 123".
        let normalizedValue = value.replace(/^\s+/, '').replace(/ {2,}/g, ' ');
        // Remove spaces after non-alphanumeric characters except hyphens: "ABC_ 123" -> "ABC_123", "ABC- 123" is preserved.
        normalizedValue = normalizedValue.replace(/[^a-zA-Z0-9-] +/g, match => match[0]);
        // Remove spaces before non-alphanumeric characters except hyphens: "ABC_ 123" -> "ABC_123", "ABC - 123" is preserved.
        normalizedValue = normalizedValue.replace(/ +(?=[^a-zA-Z0-9-])/g, '');
        if (trimTrailing) {
            normalizedValue = normalizedValue.trim();
        }
        return normalizedValue;
    };

    const handleInputChange = (value, fieldConfig) => {
        const { maxLength, allowedChars, allowedSpace } = fieldConfig;

        if (!allowedSpace) {
            value = value.trim();
        }

        if (fieldConfig.value === 'policyNumber') {
            value = normalizePolicyNumberInput(value);
        }

        if (allowedChars) {
            const regex = new RegExp(`[^${allowedChars}]`, 'g');
            value = value.replace(regex, '');
        }
        if (maxLength) {
            value = value.slice(0, maxLength);
        }

        return value;
    };

    return (
        <>
            <div className="card">
                <div className="card-body" style={{ minHeight: '400px' }}>
                    {props.hasUIComponentViewAccess && <Row className="pb-3">
                        <Column lg={2}>
                            <Button
                                id={"policy-actions-match"}
                                variant={"outline-primary"}
                                className={"btn-icon"}
                                onClick={handleApplyClick}
                                disabled={activeTab === constant.UnMatchedPolicy.tab2 || !props.hasUIComponentReadAccess}
                            >
                                <i className="bi bi-arrow-repeat me-2"></i>{label.UnmatchedPolicy.APPLY}
                            </Button>
                        </Column>
                        <Column lg={4}>
                            <Button
                                id={"policy-actions-create-customer-apply"}
                                variant={"outline-primary"}
                                className={"btn-icon"}
                                onClick={handleCreateCustomerAndApply}
                                disabled={activeTab === constant.UnMatchedPolicy.tab2 || !props.hasUIComponentReadAccess || (props.selectedTransactionIds?.length || 0) > 1}
                            >
                                <i className="bi bi-calendar me-2"></i>{label.UnmatchedPolicy.CREATECUSTOMERANDAPPLY}
                            </Button>
                        </Column>

                        <Column lg={3}>
                            <Button
                                id={"policy-actions-copy-to-cs2-apply"}
                                variant={"outline-primary"}
                                className={"btn-icon text-nowrap"}
                                onClick={handleCreateCustomerFromAtmsAndApplyTransaction}
                                disabled={activeTab === constant.UnMatchedPolicy.tab1 || !props.hasUIComponentReadAccess || (props.selectedTransactionIds?.length || 0) > 1}
                            >
                                <i className="bi bi-calendar me-2"></i>{label.UnmatchedPolicy.COPYTIOCS2ANDAPPLY }
                            </Button>
                        </Column>

                        <Column lg={3} className="text-end">
                            <Button
                                id={"policy-actions-new-customer"}
                                variant={"outline-primary"}
                                className={"btn-icon"}
                                disabled={!props.hasUIComponentReadAccess}
                            >
                                <i className="bi bi-plus me-2"></i>{label.UnmatchedPolicy.CREATE_CUSTOMER}
                            </Button>

                        </Column>
                    </Row>
                    }
                    {props.hasUIComponentViewAccess &&
                    <>
                    <Row>
                        <Column lg={12} className="p-0">
                            <strong>{label.UnmatchedPolicy.QUICK_SEARCH}</strong>
                        </Column>
                    </Row>
                    {renderQuickSearchRow()}
                   
                    </>
}

                <div className="search-results-panel">
                    {advancedSearchRows.length > 0 && renderAdvancedSearchRows()}

                    
                    <Tab.Container activeKey={activeTab} onSelect={handleTabChange}>
                        {props.hasUIComponentViewAccess&&<Nav variant="tabs" className="miniTabs">
                            <Nav.Item>
                                <Nav.Link eventKey={constant.UnMatchedPolicy.tab1} className={activeTab === constant.UnMatchedPolicy.tab1 ? 'transaction-summary-tab-active' : ''} disabled={!props.hasUIComponentReadAccess}>{label.UnmatchedPolicy.CS2CUSTOMER}</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey={constant.UnMatchedPolicy.tab2} className={activeTab === constant.UnMatchedPolicy.tab2 ? 'transaction-summary-tab-active' : ''} disabled={!props.hasUIComponentReadAccess}>{label.UnmatchedPolicy.ATMSCUSTOMER}</Nav.Link>
                            </Nav.Item>
                        </Nav>}
                    <div className="tab-content-scroll">
                        <Tab.Content>
                            <Tab.Pane eventKey={constant.UnMatchedPolicy.tab1} className="tabContent">
                                {
                                    <Row>
                                        <Column lg={12} className="p-0">
                                            <Table className="transactionSummaryTable">
                                                <thead className="tableHeader">
                                                    <tr>
                                                        <th className="tbl-header tbl-column-customer-name">{label.UnmatchedPolicy.NAME_POLICY}</th>
                                                        <th className="tbl-header tbl-column-customer-agency">{label.UnmatchedPolicy.AGENCY_CODE_STATUS}</th>
                                                        {/* <th className="tbl-header">{label.UnmatchedPolicy.SUB_AGENCY}</th> */}
                                                        <th className="tbl-header tbl-column-customer-term">{label.UnmatchedPolicy.Term}</th>
                                                        <th className="tbl-header tbl-column-customer-address">{label.UnmatchedPolicy.ADDRESS_COVERAGE}</th>
                                                        <th className="tbl-header tbl-column-customer-city">{label.UnmatchedPolicy.CITY}</th>
                                                        <th className="tbl-header tbl-column-customer-state">{label.UnmatchedPolicy.STATE}</th>
                                                        <th className="tbl-header tbl-column-customer-zip">{label.UnmatchedPolicy.ZIP}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {transactionSummaryList !== undefined && transactionSummaryList.length > 0 && transactionSummaryList.map((transaction, index) => (
                                                        <Fragment key={transaction.id}>
                                                            <tr id={transaction.id} onClick={() => handleToggle(transaction.id, transaction.agencyId, transaction.custNumber)} style={{ cursor: 'pointer' }} className={`summaryRow non-collapsible tbl-column-customer-name ${selectedRowId === transaction.id ? 'selected-row' : index % 2 === 0 ? 'alternate' : 'even'} ${transaction.allPoliciesCancelledOrPast ? 'cancelledOrPast' : ''}`}>
                                                                <td className="td-color">
                                                                    {open[transaction.id] ? <FaChevronDown className="td-color" /> : <FaChevronRight className="td-color" />} {`${transaction?.firstName || ''} ${transaction?.lastName || ''}`.trim()}
                                                                </td>
                                                                <td className="tbl-column-customer-agency">{transaction.agencyDecr}</td>
                                                                {/* <td className="truncateDesc">{activity.description}</td> */}
                                                                <td className="tbl-column-customer-term">
                                                                    {
                                                                        (transaction.term && transaction.term !== "Multiple" && !isNaN(Date.parse(transaction.term)))
                                                                            ?  CommonUtility.formateDateStringtoDate(transaction.term)
                                                                            : transaction.term
                                                                    }
                                                                </td>
                                                                <td className="tbl-column-customer-address">{transaction.address1}</td>
                                                                <td className="tbl-column-customer-city">{transaction.city}</td>
                                                                <td className="tbl-column-customer-state">{transaction.state}</td>
                                                                <td className="tbl-column-customer-zip">{transaction.zipCode}</td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={10} style={{ padding: 0 }}>
                                                                    <Collapse in={open[transaction.id]}>
                                                                        <div id={`collapse-${transaction.id}`} style={{ padding: '10px' }}>
                                                                            <Table className="policySummaryTable">
                                                                                <tbody>
                                                                                    {(transaction.policyReadDTO === undefined || transaction.policyReadDTO.length === 0) &&

                                                                                        <tr>
                                                                                            <td colSpan={10}>
                                                                                                {transaction.errorText}
                                                                                            </td>
                                                                                        </tr>
                                                                                    }

                                                                                    {transaction.policyReadDTO !== undefined && transaction.policyReadDTO.length > 0 && transaction.policyReadDTO.map((policy, index) => (
                                                                                        <>
                                                                                            <tr id={policy.id} onClick={() => handlePolicyToggle(policy.id, policy.priorPolicyId, policy.sourceId, policy.sourceTypeId, policy.companyId, policy.writingCompanyId)} style={{ cursor: 'pointer' }}
                                                                                                className={`transactionRow non-collapsible ${selectedCS2PolicyId === policy.id ? 'selected-row' : index % 2 === 0 ? 'alternate' : 'even'} ${policy.isLatest ? 'latest-policy-row' : ''}`}>

                                                                                                <td className="tbl-column-customer-name td-color">
                                                                                                    <span className="policy-number-cell">
                                                                                                        {openPolicy[policy.id] ? <FaChevronDown className="td-color" /> : <FaChevronRight className="td-color" />} {policy.policyNumber}
                                                                                                    </span>
                                                                                                </td>
                                                                                                <td className="tbl-column-customer-term">{policy.polTermStatus}</td>
                                                                                                <td className="tbl-column-customer-address">

                                                                                                    { CommonUtility.formateDate(policy.polEffDate)}{"-"}{ CommonUtility.formateDate(policy.polExpDate)}
                                                                                                </td>
                                                                                                <td className="tbl-column-customer-address">{"$" + policy.fullTermPremium}</td>
                                                                                                <td className="tbl-column-customer-city">{policy.city ? policy.city : " "}</td>
                                                                                                <td className="tbl-column-customer-state">{policy.state ? policy.state : " "}</td>
                                                                                                <td className="tbl-column-customer-zip">{policy.zipCode ? policy.zipCode : " "}</td>
                                                                                            </tr>
                                                                                            <Collapse in={openPolicy[policy.id]}>
                                                                                                <tr>
                                                                                                    <td colSpan={10}>

                                                                                                        <div id={`collapse-${policy.id}`} style={{ padding: '10px' }}>
                                                                                                            <Row className="pb-4">
                                                                                                                <Column lg={12}>
                                                                                                                    <strong>{label.UnmatchedPolicy.ADDITIONAL_POLICY}</strong>
                                                                                                                </Column>
                                                                                                            </Row>
                                                                                                            <Row className="pb-4">
                                                                                                                <Column lg={4}>
                                                                                                                    <strong style={{ color: "#878686" }}>{label.UnmatchedPolicy.PROPERTY_ADDRESS}</strong>
                                                                                                                    <div>{checkEmptyString(policy.address1) + preCommaString(policy.address2) + preCommaString(policy.city) + preCommaString(policy.zipCode) + checkEmptyString(policy.addressToDisplay)}</div>
                                                                                                                </Column>
                                                                                                                <Column lg={4}>
                                                                                                                    <strong style={{ color: "#878686" }}>{label.UnmatchedPolicy.SOURCE}</strong>
                                                                                                                    <div>{policy.source}</div>
                                                                                                                </Column>
                                                                                                                <Column lg={4}>
                                                                                                                    <strong style={{ color: "#878686" }}>A+ Reference</strong>
                                                                                                                    {/* <div><a href={policy.policyAPlusUrl??"#"}>{policy.aPlusReferenceNumber}</a></div> */}
                                                                                                                    <div><a style={{ color: "#2563eb", cursor: "pointer" }} onClick={() => policy.policyAPlusUrl ? (window.open(policy.policyAPlusUrl, '_blank')) : (preventDefault)}>{policy.aPlusReferenceNumber}</a></div>
                                                                                                                </Column>
                                                                                                            </Row>
                                                                                                            <Row className="pb-4">
                                                                                                                {/*<Column lg={4}>*/}
                                                                                                                {/*<strong style={{ color: "#878686" }}>{label.UnmatchedPolicy.Term}</strong>*/}
                                                                                                                {/*<div>{moment(policy.polEffDate).format("MM/DD/YYYY") }{"-"}{moment(policy.polExpDate).format("MM/DD/YYYY")}</div>*/}
                                                                                                                {/*</Column>*/}
                                                                                                                <Column lg={4}>
                                                                                                                    <strong style={{ color: "#878686" }}>{label.UnmatchedPolicy.PREMIUM}</strong>
                                                                                                                    <div>{"$" + policy.fullTermPremium}</div>
                                                                                                                </Column>
                                                                                                                <Column lg={4}>
                                                                                                                    <strong style={{ color: "#878686" }}>{label.UnmatchedPolicy.STATUS}</strong>
                                                                                                                    <div>{policy.polTermStatus}</div>
                                                                                                                </Column>
                                                                                                                <Column lg={4}>
                                                                                                                    <strong style={{ color: "#878686" }}>{label.UnmatchedPolicy.PRODUCER}</strong>
                                                                                                                    <div>{policy.producerName}</div>
                                                                                                                </Column>
                                                                                                            </Row>
                                                                                                            <Row className="pb-4">

                                                                                                                <Column lg={4}>
                                                                                                                    <strong style={{ color: "#878686" }}>{label.UnmatchedPolicy.DESCRIPTION}</strong>
                                                                                                                    <div>{policy.policyType}</div>
                                                                                                                </Column>
                                                                                                                <Column lg={4}>

                                                                                                                </Column>
                                                                                                            </Row>
                                                                                                        </div>


                                                                                                    </td>
                                                                                                </tr>
                                                                                            </Collapse>
                                                                                        </>
                                                                                    ))}
                                                                                </tbody>
                                                                            </Table>
                                                                        </div>
                                                                    </Collapse>
                                                                </td>
                                                            </tr>
                                                        </Fragment>
                                                    ))}
                                                    {/* </React.Fragment>
                                                            ))} */}
                                                </tbody>
                                            </Table>

                                        </Column>
                                    </Row>
                                }
                            </Tab.Pane>
                            <Tab.Pane eventKey={constant.UnMatchedPolicy.tab2} className="tabContent">
                                {
                                    <Row>
                                        <Column lg={12} className="p-0">
                                            <Table className="transactionSummaryTable">
                                                <thead className="tableHeader">
                                                    <tr>
                                                        <th className="tbl-header">Name</th>
                                                        <th className="tbl-header">Ref#</th>
                                                        <th className="tbl-header">Policy# / Agency Name</th>
                                                        <th className="tbl-header">Policy Type</th>
                                                        <th className="tbl-header">Effective Date</th>
                                                        <th className="tbl-header">Address</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {atmsCustomerList !== undefined && atmsCustomerList.length > 0 && atmsCustomerList.map((customer, index) => (
                                                        <Fragment key={customer.leadId || index}>
                                                            <tr id={customer.leadId} onClick={() => handleAtmsLeadSelection(customer.leadId)} style={{ cursor: 'pointer' }} className={`summaryRow  non-collapsible ${atmsSelectedRowId === customer.leadId ? 'selected-row' : index % 2 === 0 ? 'alternate' : 'even'}`}>
                                                                <td className="policy-name-link">
                                                                    {`${customer?.firstName || ''} ${customer?.lastName || ''}`.trim()}
                                                                </td>
                                                                <td>{customer.referenceNbr}</td>
                                                                <td>{customer.policyNbr} / {customer.agencyName}</td>
                                                                <td>{customer.policyType}</td>
                                                                <td>{ CommonUtility.formateDateStringtoDate(customer.policyExpirationDate)}</td>
                                                                <td>{[customer.mailingAddress1, customer.mailingAddress2, customer.mailingCity, customer.mailingState, customer.mailingZip].filter(Boolean).join(', ')}</td>
                                                            </tr>

                                                        </Fragment>
                                                    ))}
                                                </tbody>
                                            </Table>

                                        </Column>
                                    </Row>
                                }
                            </Tab.Pane>
                        </Tab.Content>
                    </div>
                    </Tab.Container>
                </div>


                    <CreateCustomerAndApplyPolicyPopup
                        showCreateCustomerAndApply={showCreateCustomerPopup}
                        handleClose={() => setShowCreateCustomerPopup(false)}
                        agencyList={agencyList}
                        firstName={popupData.firstName}
                        lastName={popupData.lastName}
                        middleName={popupData.middleName}
                        sourcesTypeList={sourcesTypeList}
                        onSave={handleCreateCustomerAndApplySave}
                        parentCompany={popupData.parentCompany}
                        writtingCompany={popupData.writtingCompany}
                    />

                    <ApplyPolicyPopup
                        showApplyPolicyPopup={showApplyPolicyPopup}
                        handleClose={() => setShowApplyPolicyPopup(false)}
                        agencyList={agencyList}
                        firstName={applyPopupData.firstName}
                        lastName={applyPopupData.lastName}
                        middleName={applyPopupData.middleName}
                        agencyId={agencyId}
                        sourcesTypeList={sourcesTypeList}
                        onSave={handleApplyPolicyandSave}
                        parentCompany={applyPopupData.parentCompany}
                        writtingCompany={applyPopupData.writtingCompany}
                        showCompanyInfo={applyPopupData.showCompanyInfo}
                    />
                </div>

            </div>
            {showConfirmationPopup && (
                <ConfirmModal
                    modaltitle={label.CONFIRM}
                    showConfirmation={true}
                    setConfirmation={() => { }} // Not needed
                    body={confirmationLabel}
                    showHeaderCloseButton={false}
                    closeButtonClick={() => handleConfirm(false)}
                    successButtonClick={() => handleConfirm(true)}
                    closeButtonLabel={label.NO.toUpperCase()}
                    successButtonLabel={label.YES.toUpperCase()}
                />
            )}
        </>
    )
}
export default TransactionSummaryListPanel;
